import actionTypes from '../actionTypes';

const initialState = {
    details: null,
    hasError: false,
    isLoading: true,
    restaurantId: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESTAURANT_DETAILS_LOADING:
            return {
                ...state,
                isLoading: true,
                hasError:  false,
                details: null
            };
        case actionTypes.RESTAURANT_DETAILS_LOADED:
            return {
                ...state,
                isLoading: false,
                hasError:  false,
                details: action.payload
            };
        case actionTypes.RESTAURANT_DETAILS_ERROR:
            return {
                ...state,
                isLoading: false,
                hasError:  true
            };
        case actionTypes.SET_RESTAURANT_ID:
            return {
                ...state,
                restaurantId: action.payload
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// /src/store/reducers/restaurant.js